import React from 'react';
import GalleryComp from "../components/GalleryPage/GalleryComp";

const Gallery = () => {
    return (
        <GalleryComp/>
    );
};

export default Gallery;